module.exports = __webpack_public_path__ + "static/media/banner-aicf.f98dc693.png";